import Link from 'next/link';
import PropTypes from 'prop-types';

const baseStyles =
  'px-8 py-4 rounded-xl font-medium transition-all duration-200 inline-flex items-center justify-center gap-2 touch-manipulation';
const variantStyles = {
  primary:
    'bg-brand text-white hover:bg-brand-hover hover:-translate-y-0.5 shadow-md hover:shadow-[0_8px_24px_-6px_rgba(0,0,0,0.10)] active:translate-y-0 active:shadow-sm active:scale-[0.98]',
  secondary:
    'bg-transparent border-2 border-brand text-brand hover:bg-brand hover:text-white active:scale-[0.98]',
  secondaryLight:
    'bg-transparent border-2 border-white text-white hover:bg-white hover:!text-[#0f172a] active:scale-[0.98]',
};

export function Button({
  variant = 'primary',
  children,
  className = '',
  href,
  onClick,
  type = 'button',
  disabled,
  'aria-label': ariaLabel,
  'aria-current': ariaCurrent,
  prefetch,
}) {
  const classes = `${baseStyles} ${variantStyles[variant]} ${className}`.trim();
  if (href) {
    const linkProps = {};
    if (ariaLabel != null) linkProps['aria-label'] = ariaLabel;
    if (ariaCurrent != null) linkProps['aria-current'] = ariaCurrent;
    if (prefetch != null) linkProps.prefetch = prefetch;
    return (
      <Link href={href} className={classes} {...linkProps}>
        {children}
      </Link>
    );
  }
  return (
    <button
      type={type}
      disabled={disabled}
      className={classes}
      aria-label={ariaLabel}
      onClick={onClick}
    >
      {children}
    </button>
  );
}

Button.propTypes = {
  variant: PropTypes.oneOf(['primary', 'secondary', 'secondaryLight']),
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  href: PropTypes.string,
  onClick: PropTypes.func,
  type: PropTypes.oneOf(['button', 'submit', 'reset']),
  disabled: PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-current': PropTypes.string,
  prefetch: PropTypes.bool,
};
